import React, { useState, useEffect } from 'react';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import LoadingSpinner from './LoadingSpinner';

const PayPalTourProvider = ({ children }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [scriptError, setScriptError] = useState(null);

  const paypalOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "USD",
    intent: "capture",
    components: "buttons",
    'disable-funding': 'credit,card',
    'enable-funding': 'paypal'
  };

  useEffect(() => {
    const loadPayPalScript = async () => {
      try {
        if (window.paypal) {
          setScriptLoaded(true);
          return;
        }

        const script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=USD&intent=capture`;
        script.async = true;
        
        script.onload = () => {
          setScriptLoaded(true);
        };
        
        script.onerror = (error) => {
          setScriptError(error);
          console.error('PayPal script failed to load:', error);
        };

        document.body.appendChild(script);

        return () => {
          document.body.removeChild(script);
        };
      } catch (error) {
        setScriptError(error);
        console.error('Error loading PayPal script:', error);
      }
    };

    loadPayPalScript();
  }, []);

  if (scriptError) {
    return <div>Error loading PayPal. Please try again later.</div>;
  }

  if (!scriptLoaded) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <LoadingSpinner />
        <div>Loading PayPal...</div>
      </div>
    );
  }

  return (
    <PayPalScriptProvider 
      options={paypalOptions}
      deferLoading={false}
    >
      {children}
    </PayPalScriptProvider>
  );
};

export default PayPalTourProvider; 